import { Component, OnInit } from '@angular/core';
import {JSONCards, UiValue} from "../CardStruct";
import {CardLayoutDataService} from "../card-layout-data.service";
import {ActivatedRoute, Router} from "@angular/router";
import {VariableDataService} from "../../variableDataBase/VariableDataService";

@Component({
  selector: 'app-card-computer-overview',
  templateUrl: './card-computer-overview.component.html',
  styleUrls: ['./card-computer-overview.component.css']
})
export class CardComputerOverviewComponent implements OnInit {
  jsonCards: JSONCards | undefined;
  public ready: boolean = false;
  filelink: number = -1;
  filelinkBack: number = 9999;

  constructor(private router: Router , private route: ActivatedRoute, private cardLayoutDataService : CardLayoutDataService, private variableDataService: VariableDataService) {
    // This will make sure that the card service is working on the climate computer
  }

  ngOnInit(): void {
    this.variableDataService.Get(0).subscribe(
      {
        next: uiValue => {
            // If we can retrieve a value from climate we can enable the CARDS
            this.route.paramMap.subscribe( () => {
              //this.name = params['name'];
              const id = this.route.snapshot.paramMap.get('filelink');
              let tmpLink = (id) ? parseInt(id) : 9999;
              if(( this.filelink != tmpLink) &&  (tmpLink !=0) ) {
                  this.filelinkBack = ( (this.filelink == -1) || (this.filelink == 9999) ) ? 9999 : this.filelink;
                  this.filelink = tmpLink;
                  this.InlayOut(this.filelink);
              }
            });
        }
      });
  }

  GetName(index: number) : string
  {
    return this.jsonCards ? this.jsonCards.JSONCards[index].name : "no name";
  }

  InlayOut(filelink: number): void {
    this.ready = false;
    this.cardLayoutDataService.GetData(filelink).subscribe(
      {
        next: jsonCards => {
          this.ready = true;
          this.jsonCards = jsonCards;
        }
      });
  }

  Home() {
    this.router.navigate(['/cards', {filelink: 9999}]);
  }

  }
